var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export default class FileHelper {
    /**
     * Converts a base64 encoded string to a blob.
     *
     * See: https://stackoverflow.com/a/16245768
     *
     * @param b64Data
     * @param contentType
     * @param sliceSize
     */
    static base64toBlob(b64Data, contentType = '', sliceSize = 512) {
        const byteCharacters = atob(b64Data);
        const byteArrays = [];
        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            const slice = byteCharacters.slice(offset, offset + sliceSize);
            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
        const blob = new Blob(byteArrays, { type: contentType });
        return blob;
    }
    /**
     * Converts a base64 encoded string to a Uint8Array.
     *
     * @param b64Data
     * @param contentType
     * @param sliceSize
     */
    static base64toUint8Array(b64Data) {
        const raw = window.atob(b64Data);
        const rawLength = raw.length;
        const array = new Uint8Array(new ArrayBuffer(rawLength));
        for (let i = 0; i < rawLength; i++) {
            array[i] = raw.charCodeAt(i);
        }
        return array;
    }
    /**
     * Converts a Uint8Array to a base64 encoded string
     *
     * @param array
     * @returns
     */
    static Uint8Arraytobase64(array) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = () => {
                    const value = reader.result;
                    /*
                        The result looks like
                        "data:application/octet-stream;base64,<your base64 data>",
                        so we split off the beginning:
                    */
                    const data = value.split(',', 2)[1];
                    resolve(data);
                };
                reader.onerror = error => reject(error);
                reader.readAsDataURL(new Blob([array]));
            });
        });
    }
    /**
     * Returns a string from a File.
     *
     * @param file
     */
    static fileToText(file) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = () => {
                    const value = reader.result;
                    resolve(value);
                };
                reader.onerror = error => reject(error);
                reader.readAsText(file);
            });
        });
    }
    /**
     * Returns a binary string from a File.
     *
     * @param file
     */
    static fileToBinaryString(file) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = () => {
                    const value = reader.result;
                    resolve(value);
                };
                reader.onerror = error => reject(error);
                reader.readAsBinaryString(file);
            });
        });
    }
    /**
     * Returns a base64 encoded string of a File's data.
     *
     * @param file
     */
    static fileToBase64(file) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = () => {
                    const value = reader.result;
                    let encoded = value.replace(/^.*;base64,/, '');
                    if ((encoded.length % 4) > 0) {
                        encoded += '='.repeat(4 - (encoded.length % 4));
                    }
                    resolve(encoded);
                };
                reader.onerror = error => reject(error);
                reader.readAsDataURL(file);
            });
        });
    }
    /**
     * Returns an ArrayBuffer from a File.
     *
     * @param file
     */
    static fileToArrayBuffer(file) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = () => {
                    const value = reader.result;
                    resolve(value);
                };
                reader.onerror = error => reject(error);
                reader.readAsArrayBuffer(file);
            });
        });
    }
    /**
     * Returns a Uint8Array from a File.
     *
     * @param file
     */
    static fileToUint8Array(file) {
        return __awaiter(this, void 0, void 0, function* () {
            const buffer = yield FileHelper.fileToArrayBuffer(file);
            return new Uint8Array(buffer);
        });
    }
}
//# sourceMappingURL=file-helper.js.map